import React, { Component } from 'react';
import { Row, Col} from 'reactstrap';
import RequestsList from './Requests';
import RequestCalendar from './RequestSchedulerCalendar';
import {FaRegCalendarAlt, FaList as FaGrid} from 'react-icons/fa';

class RequestsIndex extends Component {
    constructor(props) {
        super(props);
        this.state = {
            view_type: true  //default view is calendar
        }
        this.changeCalendarView = this.changeCalendarView.bind(this);
        this.changeGridView = this.changeGridView.bind(this);
    }
    changeCalendarView(){ this.setState({ view_type : true })  }
    changeGridView(){ this.setState({ view_type : false })  }


    render() {
        let content = null;
        let {view_type} = this.state;

        (view_type ===true)? content = <RequestCalendar/> : content =  <RequestsList/>

        return (
            <div className="main_container">
                <div>

                    <Row>
                        <Col sm={{ size: 2, offset: 10 }} className="text-right" >
                            <label className="Tab_header_link">View : &nbsp;</label>
                            <FaRegCalendarAlt id='Fa_calendar_icon' className="Ensemble_Icon link_cursor " onClick={this.changeCalendarView} />
                            <FaGrid id='Fa_grid_icon' className="Ensemble_Icon link_cursor " onClick={this.changeGridView} />
                        </Col>
                    </Row>
                </div>
               {content}
            </div>
        );
    }
}

export default RequestsIndex;
